import { useEffect, useRef } from "react";
import Lenis from "lenis";
import "@/App.css";
import { Toaster } from "sonner";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Lore from "@/components/Lore";
import Tokenomics from "@/components/Tokenomics";
import Roadmap from "@/components/Roadmap";
import Community from "@/components/Community";
import Footer from "@/components/Footer";

function App() {
  const lenisRef = useRef(null);

  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09 });
    lenisRef.current = lenis;
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  const scrollTo = (id) => {
    if (lenisRef.current) {
      lenisRef.current.scrollTo(id, { offset: -80, duration: 1.4 });
    } else {
      document.querySelector(id)?.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <div className="min-h-screen bg-abyss font-outfit text-zinc-200 overflow-x-clip">
      <div className="noise-overlay" aria-hidden="true" />
      <Navbar onNavigate={scrollTo} />
      <main>
        <Hero onNavigate={scrollTo} />
        <Marquee />
        <Lore />
        <Tokenomics />
        <Roadmap />
        <Community />
      </main>
      <Footer onNavigate={scrollTo} />
      <Toaster
        theme="dark"
        position="bottom-right"
        toastOptions={{
          style: {
            background: "#0F0B18",
            border: "1px solid rgba(255,107,0,0.4)",
            color: "#F3F4F6",
          },
        }}
      />
    </div>
  );
}

export default App;
